<div class="card"
    [class.is--selected]="selected">
    <i-check style="stroke: #003878"></i-check>
    <figure class="figure" *ngIf="imageUrl">
        <img [src]="imageUrl"
            [alt]="title"
            class="image">
    </figure>
    <p class="title"
        [innerHTML]="unescapedHtml"></p>
    <ng-content></ng-content>
</div>
